import { useJourneyReviewContext } from 'modules/workflows/context/JourneyReviewContext';
import { useRef } from 'react';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Exit24 } from 'ui/icons';
import { CounterBadge, CounterSubtleBadge } from 'ui/badge';
import { PanelSize } from 'ui/takeOver';
import { JourneyReviewTabs } from './JourneyReview.constants';
import {
  StyledNavTabTrigger,
  StyledReview,
  StyledNav,
  StyledNavTabGroup,
  StyledNavText,
  StyledTabsContent,
  StyledTabsGroup,
} from './JourneyReview.styles';
import { JourneyIssues } from './JourneyIssues';
import { JourneyPerformance } from './JourneyPerformance';

export const JourneyReview = () => {
  const {
    setIsOpen,
    incompleteIssuesCount,
    incompleteOptimizationsCount,
    activeTab,
    setActiveTab,
    clearCompleted,
  } = useJourneyReviewContext();
  const ref = useRef(null);

  const onClose = () => {
    setIsOpen(false);
    clearCompleted();
  };

  return (
    <StyledReview ref={ref} size={PanelSize.Small}>
      <StyledTabsGroup
        value={activeTab}
        onValueChange={(value) => {
          setActiveTab(value as JourneyReviewTabs);
        }}
      >
        <div>
          <StyledNav>
            <StyledNavText>Review</StyledNavText>
            <IconButton variant={BUTTON_VARIANTS.GHOST} onClick={onClose}>
              <Exit24 />
            </IconButton>
          </StyledNav>
          <StyledNavTabGroup>
            {Object.values(JourneyReviewTabs).map((tabName) => {
              const tabCount =
                tabName === JourneyReviewTabs.Issues
                  ? incompleteIssuesCount
                  : incompleteOptimizationsCount;
              const Badge = tabName === activeTab ? CounterBadge : CounterSubtleBadge;
              return (
                <StyledNavTabTrigger value={tabName} data-test={`${tabName}-tab`} key={tabName}>
                  {tabName} {tabCount > 0 && <Badge>{tabCount}</Badge>}
                </StyledNavTabTrigger>
              );
            })}
          </StyledNavTabGroup>
        </div>
        <StyledTabsContent value={JourneyReviewTabs.Issues}>
          <JourneyIssues />
        </StyledTabsContent>
        <StyledTabsContent value={JourneyReviewTabs.Performance}>
          <JourneyPerformance />
        </StyledTabsContent>
      </StyledTabsGroup>
    </StyledReview>
  );
};
